import { UploadLookup } from './upload-lookup.interface';

export interface DocumentsUpload {
  [name: string]: UploadLookup;
}

//stores all document lookups by section
export interface DocumentsCategoriesBySection {
  [name: string]: DocumentsUpload;
}
